import React, {useMemo} from 'react'
import styled from 'styled-components'
import {useWindowMode} from 'windows'
import {FontSizeType} from 'types/commons'
import {Icon, Paragraph} from 'common/components'
import {TemplateDropboxHeaderProps} from './TemplateDropboxHeaderProps'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`

export default function TemplateDropboxHeader({
  title,
  color,
  iconType,
  iconColor,
}: TemplateDropboxHeaderProps) {
  const mode = useWindowMode()

  const fontSize = useMemo<FontSizeType>(
    () => (mode === 'website' ? 'xl' : 'l'),
    [mode],
  )

  const iconSize = useMemo(() => (mode === 'website' ? 28 : 20), [mode])

  return (
    <StyledContainer>
      <Icon size={iconSize} type={iconType} color={iconColor} />
      <Paragraph fontSize={fontSize} fontWeight="bold" color={color}>
        {title}
      </Paragraph>
    </StyledContainer>
  )
}
